import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import RoamRest from "../../Assets/Projects/RoamRest.png";
import Rajkaushal from "../../Assets/Projects/RajKaushal.png";
import Samadhaan from "../../Assets/Projects/Samadhaan.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
        Here are a few projects I've worked on or am working on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RoamRest}
              isBlog={false}
              title="RoamRest"
              description="RoamRest is a platform to list and find homes or places for rent, built with Node.js, Express, MongoDB, and Tailwind CSS. It features advanced search, seamless property listing, ratings, reviews, and the ability to showcase your property to potential renters effortlessly"
              ghLink="https://github.com/ashish789bhoi/RoamRest"
              demoLink="https://akb-roamrest.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Rajkaushal}
              isBlog={false}
              title="Rajkaushal"
              description="RajKaushal is a job portal designed for unemployed youth in Rajasthan, built with Node.js, Express, MongoDB, and Tailwind CSS. It simplifies job searches based on skills, user-friendly navigation, skill-based recommendations, and connects employers with skilled candidates."
              ghLink="https://github.com/ashish789bhoi/Rajkaushal"
              demoLink="https://tech-titans-rajkaushal.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Samadhaan}
              isBlog={false}
              title="Samadhaan"
              description="Creating a prototype for the 'Samadhaan' website, built with HTML, CSS, JavaScript, Node.js, and MySQL, which bridges the gap between the municipal corporation and citizens. It focuses on delivering seamless functionalities and an intuitive user experience to address citizen needs efficiently"
              ghLink="https://github.com/ashish789bhoi/Samaadhaan_Prototype"
              demoLink="https://akb-samaadhaan.vercel.app/"              
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
